export { BadgeCounter } from './BadgeCounter'
export type {
  BadgeCounterProps,
  BadgeCounterIProps,
  BadgeCounterVariant,
} from './BadgeCounter'
